import React from "react";
const OImage = ({ src, fallbackUrl, ...rest }) => {
  return (
    <>
      <img
        loading="lazy"
        src={src}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = fallbackUrl || '/images/no-images.png';
        }}
        {...rest}
      />
    </>
  );
};

export default OImage;
